import React from "react";
import SwiperCore, { Navigation, Pagination, Thumbs } from "swiper";
import Image from "components/image";
import RichText from "components/rich-text";
import Money from "components/money";
import BundleDetails from "./modal";
import AddToCart from "components/add-to-cart";
import ReviewsWidget from "utils/reviews";
import BoxWithModal from "components/box-with-modal";
import RenderAccordions from "../product/details/accordions";
import PaymentIcons from "components/payment-icons";
import useStickyElement from "hooks/useStickyElement";
import ImageSlideShow from "components/image-slide-show";
import FreeShipping from "components/free-shipping";
import GiftCard from "./gift-card";
import { useGlobalContext } from "context/global";

SwiperCore.use([Thumbs, Pagination, Navigation]);

const ProductSingle = ({ data }) => {
	const { translation, paymentIcons } = useGlobalContext();
	const { images = [], title, offerPrice } = data.product ?? {};
	const { bulletPoints, showReviews } = data;
	const bottom = true;

	useStickyElement(".make-sticky", bottom);

	const price = offerPrice ?? data?.product?.variant?.price;
	const pricePer100 = price * 100 / data?.product?.details?.weight;

	return data?.product?._type === "giftCard" ? <GiftCard product={data?.product} /> : (
		<div className="w-90 m-auto flex flex-col lg:flex-row justify-between my-10 gap-x-10 hd-screen-max-width product-single">
			<div className="w-full my-2">
				<ImageSlideShow images={images} />
			</div>

			<div className="flex flex-col md:mt-10 w-full md:sticky md:top-20 md:h-full">
				<h2>{title}</h2>

				{showReviews && <ReviewsWidget sku={data.product?.variant?.sku} />}

				<div className="my-3">
					<RichText value={data.description} />
				</div>

				{offerPrice && (
					<div className="my-3">
						<BundleDetails data={data} />
					</div>
				)}

				{pricePer100 > 0 &&
					<span className="italic text-gray-500 my-3">
						<Money value={pricePer100?.toFixed(2)} /> {translation.other?.for} 100g {translation.other?.incVat},
						{translation.other?.incShipping}
					</span>
				}

				<div className="sticky make-sticky">
					<div className="w-full flex md:w-3/4 my-3 md:justify-start justify-center">
						<AddToCart product={data.product} text={translation?.other?.inCart} openCart={true} />
					</div>

					<FreeShipping className="my-3 md:justify-start" />

				</div>
				{paymentIcons?.length && <PaymentIcons data={paymentIcons} settings={true} />}
				<div className="my-3 text-lg">
					{bulletPoints?.map((e) => (
						<div key={e._key} className="flex gap-5 my-2 items-center">
							<Image width="30" image={e.icon} alt={e.icon.alt} />
							<span>{e.text}</span>
						</div>
					))}
					{data?.showKlarna && data?.klarna && (
						<div className="w-full md:w-4/5">
							<BoxWithModal data={data?.klarna} />
						</div>
					)}
				</div>
				<div className="pb-10 pt-2.5">
					<RenderAccordions accordions={data?.accordions} />
				</div>
			</div>
		</div>
	);
};

export default ProductSingle;
